import axios from 'axios';

export const getLibraryFolders = async (token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/folders`;
    try {
        const response = await axios.get(apiUrl, {
            headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching library folders:', error);
        throw error;
    }
};

export const resolveLibraryFolder = async (path, token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/folders/resolve`;
    const response = await axios.get(apiUrl, {
        params: { path },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    return response.data;
};

export const getFolderPractices = async (folderId, { language, token } = {}) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/folders/${folderId}/practices`;
    const response = await axios.get(apiUrl, {
        params: { language },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    return response.data;
};
